<template>
<div>
    <stateRestriction v-if="showModel" @close="showModel = false"></stateRestriction>
    <section class="section_checkout-nav">
        <div class="checkout-top-nav-elements">
            <a href="#" class="logo-link w-inline-block"><img sizes="(max-width: 479px) 100vw, 64.421875px" :srcset="`${require('@/assets/images/NewSelf_Logo-p-500.png')} 500w, ${require('@/assets/images/NewSelf_Logo-p-800.png')} 800w`" alt="" src="@/assets/images/NewSelf_Logo.png" loading="lazy" class="image-414"></a>
            <div class="form-nav-div-2">
                <a href="#" class="back-link-2 w-inline-block">
                    <div class="text-block-817">&lt;-</div>
                </a>
                <div class="progress-div-2">
                    <div>
                        <div class="step-text">Checkout</div>
                    </div>
                    <div class="progress-precent-div">
                        <div class="percent-prog"></div>
                        <div class="percent-text">% Complete</div>
                    </div>
                </div>
            </div>
            <div class="checkout-help-wrap">

            </div>
        </div>
    </section>
    <section class="section_checkout-body">
        
        <div class="checkout-left-div">
            <div class="checkout-header">Start your health transformation!</div>
            <div class="checkout-sub">Live healthier, stronger and longer with NewSelf.</div>
            <div class="checkout-summary-div mobile">
                <div class="summary-top">
                    <div class="checkout-form-header">Order Summary<br></div>
                    <div class="text-block-819">

                    </div>
                </div>
                <div class="dropdown-sum update">
                    <div class="order-summary-div">
                        <div data-delay="0" data-hover="false" class="order-dropdown w-dropdown">
                            <div class="dropdown-sum-toggle w-dropdown-toggle">
                                <div class="open-drop-text"  @click="orderOpen = !orderOpen">
                                    <div class="text-block-336 step-1 update">Tap to access full order details</div>
                                    <div class="icon-19 w-icon-dropdown-toggle" :class="{ 'w--open': orderOpen }"></div>
                                </div>
                                <!-- Replace static order content with v-for loop -->
                                <div class="order-div" v-for="item in cartFirstItem" :key="item.id">
                                    <div class="div-block-960 new">
                                        <div class="div-block-976">
                                            <div class="div-block-974">
                                                <div class="checkout-product-div">
                                                    <img :src="item.image" loading="lazy" :alt="item.name">
                                                </div>
                                                <div class="div-block-975">
                                                    <div class="text-block-161">{{ item.quantity }}</div>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="product-name-2">{{item.name}}</div>
                                                <div class="text-block-850">{{ item.subheader }}</div>
                                            </div>
                                        </div>
                                        <div class="text-block-141 new">${{ item.price }}</div>
                                        <div class="div-block-1778">
                                            <div class="item-price-text">${{ item.retail_price }}</div>
                                            <div class="text-block-849">Billed monthly</div>
                                        </div>
                                    </div>
                                    <a href="#" class="link-block-66 w-inline-block" @click.prevent="removeFromCart(item.id)">
                                        <img src="@/assets/images/icon_trash.svg" loading="lazy" alt="">
                                    </a>
                                </div>
                            </div>
                            <nav class="dropdown-summary w-dropdown-list" :class="{ 'w--open': orderOpen }">
                                <div class="order-div" v-for="item in cartItemsMinusFirst" :key="item.id">
                                    <div class="div-block-960 new">
                                        <div class="div-block-976">
                                            <div class="div-block-974">
                                                <div class="checkout-product-div"><img :src="item.image" loading="lazy" :alt="item.name"></div>
                                                <div class="div-block-975">
                                                    <div class="text-block-161">{{item.quantity}}</div>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="product-name-2">{{item.name}} <br></div>
                                                <div class="text-block-850">{{item.subheader}}</div>
                                            </div>
                                        </div>
                                        <div class="text-block-141 new">${{item.price}}</div>
                                        <div class="div-block-1778">
                                            <div class="item-price-text">${{item.retail_price}}</div>
                                            <div class="text-block-849">Billed monthly</div>
                                        </div>
                                    </div>
                                    <a href="#" class="link-block-66 w-inline-block"><img src="@/assets/images/icon_trash.svg" loading="lazy" alt=""></a>
                                </div>
                            </nav>
                        </div>
                    </div>
                </div>
                <div class="checkout-summary-entry new">
                    <div class="text-block-821">Shipping</div>
                    <div class="text-block-822">FREE</div>
                </div>
                <div class="checkout-summary-entry new">
                    <div class="text-block-821">Discount</div>
                    <div class="text-block-822">${{ getDiscount.toFixed(2) }}</div>
                </div>
                <div class="total-amount">
                    <div class="total-price-text">Total</div>
                    <div class="total-price-text">${{ finalTotal.toFixed(2) }}</div>
                </div>
                <div class="summary-sub"><br/></div>
                <form style="width: 100%; display: flex;" @submit.prevent="handleCouponSubmit">
                <div class="promo-div-2" style="width: 100%;">
                    <div class="form-block-11 checkout w-form">
                        
                            <input class="tf_textfield-3 promo checkout w-input" v-model="couponInput" maxlength="256" name="Promo-Code-2" data-name="Promo Code 2" placeholder="Promo Code" type="text" id="Promo-Code-2" required="">
                            <div class="w-form-fail" style="display: block;" v-if="errorMessage">
                            <div>{{errorMessage}}</div>
                        </div>
                    </div>
                    <div class="promo-button-div">
                        <button type="submit" class="checkout-button-3 promo w-button">SUBMIT</button>
                    </div>
                </div>
            </form>
            </div>
            <form @submit.prevent="getStripeToken">
            <div class="card-div">
                <div class="text-block-705">Express Payment</div>
                <div class="link-block-43 w-inline-block" ref="expresscheckoutelement"></div>
                <div class="card-form w-form">
                    <div class="card-top-div">
                            <div class="text-block-707">Credit card</div>
                            <div class="cards-div"><img width="Auto" loading="lazy" alt="" src="https://cdn.prod.website-files.com/66ac7d81f3eb9a615c96a5be/66cf3a666ac0b6038a820d99_visa.png" class="image-416"><img width="35" loading="lazy" alt="" src="https://cdn.prod.website-files.com/66ac7d81f3eb9a615c96a5be/66cf3a666ac0b6038a820d3d_mastercard.png" class="image-416"><img width="35" loading="lazy" alt="" src="https://cdn.prod.website-files.com/66ac7d81f3eb9a615c96a5be/66cf3a676ac0b6038a820dc2_AmEx.png" class="image-416"><img width="35" loading="lazy" alt="" src="https://cdn.prod.website-files.com/66ac7d81f3eb9a615c96a5be/66cf3a666ac0b6038a820d29_discover.png" class="image-416"></div>
                        </div>
                        <div class="card-fields-div">
                            <div class="address-div" style="width:100%">
                                <google-places-autocomplete :api-key="googleMapsApiKey" @address-updated="getAddressData" />
                            </div>

                            <div ref="card" class="my-input"></div>

                            <label class="w-checkbox">
                                <input type="checkbox" name="checkbox-6" id="checkbox-6" data-name="Checkbox 6" class="w-checkbox-input">
                                <span class="checkbox-label-16 w-form-label" for="checkbox-6">I have read and agree to the website <a href="https://newselfrx.com/returns-and-refund" target="_blank">Refund Policy</a> and <a href="https://newselfrx.com/terms-of-use" target="_blank">Terms and Conditions</a></span>
                            </label>
                            <label class="w-checkbox">
                                <input type="checkbox" name="checkbox-6" id="checkbox-6" data-name="Checkbox 6" class="w-checkbox-input">
                                <span class="checkbox-label-16 w-form-label" for="checkbox-6">I certify that I am at least 18 years of age</span>
                            </label>
                            <label class="w-checkbox">
                                <input type="checkbox" name="checkbox-6" id="checkbox-6" data-name="Checkbox 6" class="w-checkbox-input">
                                <span class="checkbox-label-16 w-form-label" for="checkbox-6">I agree to the <a href="https://newselfrx.com/terms-of-use" target="_blank">Terms of Use</a>, <a href="https://newselfrx.com/privacy-policy" target="_blank">Privacy Policy</a>, <a href="https://newselfrx.com/hipaa" target="_blank">HIPPA Notice</a> and <a href="https://newselfrx.com/telehealth-consent" target="_blank">Telehealth Consent</a></span>
                            </label>
                            <label class="w-checkbox">
                                <input type="checkbox" name="checkbox-6" id="checkbox-6" data-name="Checkbox 6" class="w-checkbox-input">
                                <span class="checkbox-label-16 w-form-label" for="checkbox-6">I agree to be billed for ${{finalTotal}} the first month and ${{parseFloat(cartTotalNoDiscount)}} for each month thereafter until canceled. If I cancel after the first month i will forfeit the discount and be charged the full price. <a href="#">Terms of condition</a> of this program</span>
                            </label>
                        </div>
                        <div class="apple-pay-radio-div"><label class="w-radio"><input type="radio" name="radio-2" id="radio-2" data-name="Radio 2" class="w-form-formradioinput w-radio-input" value="Radio 2"><span class="w-form-label" for="radio-2">Apple Pay</span></label><img loading="lazy" src="@/assets/images/Apple_Pay_logo.svg" alt="" class="image-415"></div>
                    
                        <div class="w-form-fail" style="display:block" v-if="paymentError">
                                <div>{{ errorMessage }}.</div>
                        </div>
                </div>
            </div>
            <button class="checkout-button-3 w-button fixmobile changecolor">
                <span v-if="submitted"><img src="@/assets/images/submitted.svg"></span>
                <span v-else>Pay Now</span>
            </button>
        </form>
            <div class="desktop-pay-button-div">
                <div class="div-block-1763">
                    <div class="text-block-820">In order for us to send you your medication, you MUST complete the brief medical form immediately after checking out.</div>
                </div>
                <div class="secure-payment-div"><img width="130" loading="lazy" alt="" src="@/assets/images/paymentsecure.422c0e1.png"></div>
            </div>
        </div>
        <div class="checkout-right-div">
            <div class="mobile-pay-button-div">
                <div class="div-block-1763">
                    <div class="text-block-820">In order for us to send you your medication, you MUST complete the brief medical form immediately after checking out.</div>
                </div>
                <div class="secure-payment-div"><img width="130" loading="lazy" alt="" src="@/assets/images/paymentsecure.422c0e1.png"></div>
            </div>
            <div class="checkout-summary-div desktop">
                <div class="summary-top">
                    <div class="checkout-form-header box">Order summary<br></div>
                    <div class="text-block-819"></div>
                </div>
                <div class="dropdown-sum update">
                    <div class="order-summary-div">
                        <div data-delay="0" data-hover="false" class="order-dropdown w-dropdown">
                            <div class="dropdown-sum-toggle w-dropdown-toggle">
                                <!-- Replace static order content with v-for loop -->
                                <div v-for="item in cartItems" :key="item.id" class="order-div">
                                    <div class="div-block-960 new">
                                        <div class="div-block-976">
                                            <div class="div-block-974">
                                                <div class="checkout-product-div">
                                                    <img :src="item.image" loading="lazy" :alt="item.name">
                                                </div>
                                                <div class="div-block-975">
                                                    <div class="text-block-161">{{ item.quantity }}</div>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="product-name-2">{{ item.name }}<br></div>
                                                <div class="text-block-850">{{ item.subheader }}</div>
                                            </div>
                                        </div>
                                        <div class="text-block-141 new">${{ item.price }}</div>
                                        <div class="div-block-1778">
                                            <div class="item-price-text">${{ item.retail_price }}</div>
                                            <div class="text-block-849">Billed monthly</div>
                                        </div>
                                    </div>
                                    <a href="#" class="link-block-66 w-inline-block" @click.prevent="removeFromCart(item.id)">
                                        <img src="@/assets/images/icon_trash.svg" loading="lazy" alt="">
                                    </a>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="checkout-summary-entry new">
                    <div class="text-block-821">Shipping</div>
                    <div class="text-block-822">FREE</div>
                </div>
                <div class="checkout-summary-entry new">
                    <div class="text-block-821">Discount</div>
                    <div class="text-block-822">${{ getDiscount.toFixed(2) }}</div>
                </div>
                <div class="total-amount">
                    <div class="total-price-text">Total</div>
                    <div class="total-price-text">${{ finalTotal.toFixed(2) }}</div>
                </div>
                <div class="summary-sub"><br/></div>
                <form style="width: 100%; display: flex;" @submit.prevent="handleCouponSubmit">
                <div class="promo-div-2" style="width: 100%;">
                    <div class="form-block-11 checkout w-form">
                        <input class="tf_textfield-3 promo checkout w-input" v-model="couponInput" maxlength="256" name="Promo-Code-2" data-name="Promo Code 2" placeholder="Promo Code" type="text" id="Promo-Code-2" required="">
                        
                        <div class="w-form-fail" style="display: block;" v-if="errorMessage">
                            <div>{{errorMessage}}</div>
                        </div>
                    </div>
                    <div class="promo-button-div">
                        <button type="submit" class="checkout-button-3 promo w-button">SUBMIT</button>
                    </div>
                </div>
                </form>
            </div>
        </div>
    </section>
</div>
</template>

<script>
import {
    loadStripe
} from '@stripe/stripe-js';
import GooglePlacesAutocomplete from '../common/GooglePlacesAutocomplete.vue'
import stateRestriction from '../common/stateRestriction.vue'
import coupons from "@/utils/coupons.json"
import {
    mapGetters,
    mapActions
} from 'vuex';

export default {
    name: 'CheckoutComponent',
    components: {
        GooglePlacesAutocomplete,
        stateRestriction
    },
    props: ['baseUrl', 'stripeKey', 'googleMapsApiKey'],
    data() {
        return {
            orderOpen: false,

            all_coupons: coupons,
            submitted: false,
            paymentError: false,
            showModel: false,
            stripe: null,
            card: null,
            elements: null,
            expressCheckoutElement: null,
            user: null,
            customerInfo: {
                id: '',
                addressLine1: '',
                addressLine2: '',
                city: '',
                state: '',
                zip: ''
            },
            paymentInfo: {
                id: '',
                cardToken: '',
                amount: 499,
                discount: 0,
                medication: '',
                couponCode: '',
                drug_mode: '',
                pricing_plan: 'price_1PvfK3GUo9kSCmX1xgHRvMui',
                couponId: '4JcFJT8Z',
                paymentMethod: null
            },
            couponValid: true,
            couponApplied: false,
            errorMessage: '',
            stripeInitialized: false,
            couponInput:'',
        };
    },
    computed: {
        ...mapGetters([
            'cartItems',
            'cartTotal',
            'cartDiscount',
            'cartTotalNoDiscount',
        ]),
        canSubmit() {
            return this.cartItems.length > 0 &&
                this.termsAccepted &&
                this.ageVerified &&
                this.customerInfo.addressLine1 &&
                this.customerInfo.city &&
                this.customerInfo.state &&
                this.customerInfo.zip;
        },
        finalTotal() {
            if(this.couponApplied){
                return this.cartTotalNoDiscount - this.paymentInfo.discount
            }
            return this.cartTotal;
        },
        amountInCents() {
            return Math.round(this.finalTotal * 100);
        },
        getDiscount(){
            if(this.couponApplied){
                return this.paymentInfo.discount
            }
            return this.cartDiscount;
        },
        cartFirstItem() {
            try {
                return [this.cartItems[0]];
            } catch (error) {
                return [];
            }
        },
        cartItemsMinusFirst() {
            let temp = this.cartItems;
            return temp.slice(1);
        }
    },
    watch: {
        '$refs.card'(newVal) {
            if (newVal && !this.stripeInitialized) {
                this.initializeStripeElements();
            }
        },
        '$refs.expresscheckoutelement'(newVal) {
            if (newVal && this.stripe && !this.expressCheckoutElement) {
                this.initializeExpressCheckout();
            }
        }
    },
    async mounted() {
        try {
            this.stripe = await loadStripe(this.stripeKey);
            this.checkRouteForDiscount();
            
            // Wait for next tick to ensure refs are available
            this.$nextTick(() => {
                if (this.$refs.card) {
                    this.initializeStripeElements();
                }
                if (this.$refs.expresscheckoutelement) {
                    this.initializeExpressCheckout();
                }
            });
        } catch (error) {
            console.error('Error initializing Stripe:', error);
            this.errorMessage = 'Failed to initialize payment system';
        }
    },
    methods: {
        ...mapActions([
            'removeFromCart',
            'updateCartQuantity',
            'clearCart'
        ]),
        
        initializeStripeElements() {
            if (!this.stripe || !this.$refs.card || this.stripeInitialized) return;
            
            try {
                const elements = this.stripe.elements();
                this.card = elements.create('card', {
                    style: {
                        base: {
                            fontSize: '16px',
                            color: '#000',
                            fontWeight: 400,
                            '::placeholder': {
                                color: '#000',
                            },
                        },
                        invalid: {
                            iconColor: '#FFC7EE',
                            color: 'red',
                        },
                    },
                });
                
                this.card.mount(this.$refs.card);
                this.stripeInitialized = true;
            } catch (error) {
                console.error('Error initializing Stripe elements:', error);
                this.errorMessage = 'Failed to initialize payment form';
            }
        },

        initializeExpressCheckout() {
            console.log("checked this");
            if (!this.stripe || !this.$refs.expresscheckoutelement || this.expressCheckoutElement) return;
            console.log("now checked this");
            try {
                this.elements = this.stripe.elements({
                    mode: 'subscription',
                    amount: this.amountInCents,
                    currency: 'usd',
                    setupFutureUsage: 'off_session',
                    paymentMethodCreation: 'manual'
                });

                this.expressCheckoutElement = this.elements.create('expressCheckout');
                this.expressCheckoutElement.mount(this.$refs.expresscheckoutelement);
                this.expressCheckoutElement.on('click', this.handleClick);
                this.expressCheckoutElement.on('confirm', this.handleConfirm);
            } catch (error) {
                console.error('Error initializing express checkout:', error);
                this.errorMessage = 'Failed to initialize express payment options';
            }
        },

        async handleClick(event) {
            const options = {
                shippingAddressRequired: true,
                shippingRates: [{
                    id: 'free-shipping',
                    displayName: 'Free shipping',
                    amount: 0,
                    deliveryEstimate: {
                        maximum: {
                            unit: 'day',
                            value: 7
                        },
                        minimum: {
                            unit: 'day',
                            value: 1
                        }
                    }
                }],
                lineItems: [{
                    name: `${this.paymentInfo.plan} Program`,
                    amount: this.amountInCents
                }]
            };
            event.resolve(options);
        },

        async handleConfirm(event) {
            try {
                this.customerInfo.addressLine1 = event.shippingAddress.address.line1;
                this.customerInfo.addressLine2 = event.shippingAddress.address.line2;
                this.customerInfo.city = event.shippingAddress.address.city;
                this.customerInfo.state = event.shippingAddress.address.state;
                this.customerInfo.zip = event.shippingAddress.address.postal_code;

                const { error, paymentMethod } = await this.stripe.createPaymentMethod({
                    elements: this.elements,
                    params: {
                        billing_details: event.billingDetails
                    }
                });

                if (error) {
                    console.error('Error finalizing payment:', error);
                    this.errorMessage = error.message;
                    this.submitted = false;
                    event.reject();
                } else {
                    this.paymentInfo.paymentMethod = paymentMethod.id;
                    const response = await this.$axios.post(`${this.baseUrl}/api/create-payment-profile`, this.paymentInfo);
                    if (response.data.status === 'success') {
                        await this.updateAddress();
                        this.pushToRoute(response.data);
                        event.resolve();
                    } else {
                        this.errorMessage = response.data.message || 'Payment failed';
                        this.submitted = false;
                        event.reject();
                    }
                }
            } catch (error) {
                console.error('Error in handleConfirm:', error);
                this.errorMessage = error.message || 'An error occurred during payment';
                this.submitted = false;
                event.reject();
            }
        },

        checkRouteForDiscount() {
            this.user = this.$store.getters.user;
            this.customerInfo.id = this.user.id;
            this.paymentInfo.id = this.user.id;
            this.paymentInfo.drug_mode= "Vile"
        },

        async handleCouponSubmit() {
            this.errorMessage=null;
            if (!this.couponInput) {
                this.errorMessage = 'Please enter a coupon code';
                return;
            }
            this.paymentInfo.couponCode= this.couponInput;
            await this.validateCoupon();
        },
        async validateCoupon() {
            if (this.couponApplied) return;

            try {
                const response = await this.$axios.post(`${this.baseUrl}/api/validate-coupon`, {
                    coupon: this.paymentInfo.couponCode
                });
                
                if (response.data.status === 'success') {
                    this.couponValid = true;
                    this.couponApplied = true;
                    this.paymentInfo.couponId = response.data.coupon_id;
                    let discountAmount = 0;
                    if (response.data.c_type == 1) {
                        discountAmount = response.data.c_val;
                    } else {
                        discountAmount = Math.round((this.cartTotal * response.data.c_val) / 100);
                    }
                    this.paymentInfo.discount = discountAmount;
                    await this.initializeExpressCheckout();
                } else {
                    this.couponValid = false;
                    this.errorMessage = 'Invalid Coupon.';
                }
            } catch (error) {
                console.error('Error validating coupon:', error);
                this.errorMessage = 'An error occurred while validating the coupon.';
                this.couponValid = false;
            }
        },

        getAddressData(address) {
            if (["MS", "LA"].includes(address.state)) {
                this.showModel = true;
            } else {
                this.customerInfo.addressLine1 = address.street;
                this.customerInfo.addressLine2 = address.address_line2;
                this.customerInfo.city = address.city;
                this.customerInfo.state = address.state;
                this.customerInfo.zip = address.zip;
                this.updateAddress();
            }
        },

        async updateAddress() {
            try {
                await this.$axios.post(`${this.baseUrl}/api/save-address`, this.customerInfo);
            } catch (error) {
                console.error('Error updating address:', error);
                throw new Error('Failed to update address');
            }
        },

        async getStripeToken() {
            try {
                this.submitted = true;
                this.paymentError = false;
                
                const result = await this.stripe.createToken(this.card);
                if (result.error) {
                    this.errorMessage = result.error.message;
                    this.paymentError = true;
                    this.submitted = false;
                } else {
                    this.paymentInfo.cardToken = result.token.id;
                    await this.processPayment();
                }
            } catch (error) {
                console.error('Error getting Stripe token:', error);
                this.errorMessage = 'An error occurred while processing your payment.';
                this.paymentError = true;
                this.submitted = false;
            }
        },

        async processPayment() {
            try {
                this.paymentError = false;
                const response = await this.$axios.post(`${this.baseUrl}/api/create-payment-profile`, this.paymentInfo);
                
                if (response.data.status === 'success') {
                    await this.updateAddress();
                    this.pushToRoute(response.data);
                    this.submitted = false;
                } else {
                    this.paymentError = true;
                    this.errorMessage = response.data.message || 'Payment processing failed';
                    this.submitted = false;
                }
            } catch (error) {
                console.error('Error processing payment:', error);
                this.paymentError = true;
                this.errorMessage = error.message || 'Failed to process payment';
                this.submitted = false;
            }
        },

        pushToRoute(data) {
            this.$router.push({
                name: 'PaymentThanks',
                query: {
                    "id": this.paymentInfo.id,
                    "health_id": data.health_id
                }
            });
        },

        beforeDestroy() {
            // Cleanup Stripe elements
            if (this.card) {
                this.card.destroy();
            }
            if (this.expressCheckoutElement) {
                this.expressCheckoutElement.destroy();
            }
        }
    }
};
</script>

<style scoped>
.changecolor{
    background-color: var(--light-green);
}
.link-block-43{
    background-color: #fff;
}
.my-input {
    padding: 15px;
    border: 1px solid black;
    border-radius: 9px;
    margin-bottom: 15px;
    height: '55px';
}

.tf_textfield.w-input.StripeElement {
    align-content: center;
}

.strikethrough {
    text-decoration: line-through;
    text-decoration-color: red;
    text-decoration-thickness: 2px;
}

.promo-div {
    justify-content: space-between;
    display: block;
}

.form-block-10.checkout {
    width: 100%;
    display: flex;
    gap: 10px;
}
@media screen and (max-width: 479px) {
    .checkout-summary-div.mobile {
        background-color: #fff;
    }
    .order-div {
        background-color: #fff;
    }
    .order-summary-div {
        background-color: #fff;
    }
    .fixmobile{
        margin-top:95px !important;
    }
}
</style>
